import { HeatsResponse, useHeatsService } from '@app/api/heats';
import { GetHeatsResponseDTO } from '@app/api/heats/useHeatsService';
import { useState } from 'react';
import { InfoObject } from "./types"
import { CalculationMode } from '@app/utils/calculationModeOptions';

const useLoadArchivedHeats = (): [
  InfoObject<GetHeatsResponseDTO>,
  (
    startDate: string | null,
    endDate: string | null,
    page: number | null,
    rowsPerPage: number,
    heatName: string | null,
    sorting: string | null,
    calculationMode: CalculationMode | null
  ) => Promise<void>,
  () => void,
] => {
  const initialState: InfoObject<GetHeatsResponseDTO> = {
    status: "idle",
    data: {
      items: [] as HeatsResponse[],
      page: null,
      total: 0
    },
  }

  const [infoObject, setInfoObject] = useState<InfoObject<GetHeatsResponseDTO>>(initialState);

  const { getHeats } = useHeatsService();

  const loadArchivedHeats = async (
    startDate: string | null,
    endDate: string | null,
    page: number | null,
    rowsPerPage: number,
    heatName: string | null,
    sorting: string | null,
    calculationMode: CalculationMode | null
  ) => {
    try {
      setInfoObject({ ...infoObject, status: "loading" });
      const data = await getHeats({ startDate, endDate, page, size: rowsPerPage, heatName, sorting, calculationMode });
      setInfoObject({ data, status: "succeeded" });
    } catch (err) {
      
      setInfoObject({ ...infoObject, status: "error" });
    }
  };

  const setIdle = () => {
    setInfoObject({ ...infoObject, status: "idle" });
  }
  return [infoObject, loadArchivedHeats, setIdle];
}

export default useLoadArchivedHeats;